/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, computed, flow, toJS } from 'mobx';
import get from 'lodash/get';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import fetch from '../fetch';

class SettingsStore {
    @observable countries = [];
    @observable platforms = [];
    @observable staff = [];
    @observable videos = [];
    @observable rbac = [];

    constructor() {
        this.baseUrl = '/api/core/settings';
    }

    @action
    reset = () => {
        this.countries = [];
        this.platforms = [];
        this.staff = [];
        this.videos = [];
        this.rbac = [];
    };

    @action.bound
    loadCountries = flow(function*() {
        try {
            const response = yield fetch.get({ url: '/api/core/settings/countries' });
            if (!response.error) {
                this.countries = response;
            }
        } catch (e) {
            console.warn(e);
        }
    });

    @action.bound
    loadPlatforms = flow(function*() {
        try {
            const response = yield fetch.get({ url: '/api/core/settings/platforms' });
            if (!response.error) {
                this.platforms = response;
            }
        } catch (e) {
            console.warn(e);
        }
    });

    @action.bound
    loadStaff = flow(function*() {
        try {
            const response = yield fetch.get({ url: '/api/core/settings/staff' });
            if (!response.error) {
                this.staff = response;
            }
        } catch (e) {
            console.warn(e);
        }
    });

    @action.bound
    loadVideos = flow(function*() {
        try {
            const response = yield fetch.get({ url: '/api/core/settings/videos' });
            if (!response.error) {
                this.videos = response;
            }
        } catch (e) {
            console.warn(e);
        }
    });

    @action.bound
    loadRbac = flow(function*() {
        try {
            const response = yield fetch.get({ url: '/api/core/settings/rbac' });
            if (!response.error) {
                this.rbac = response;
            }
        } catch (e) {
            console.warn(e);
        }
    });

    @computed
    get countriesForSelect() {
        return sortBy(
            map(toJS(this.countries), (text, value) => ({
                text,
                value,
            })),
            'text'
        );
    }

    @computed
    get platformsForSelect() {
        return map(toJS(this.platforms), ({ name }, value) => ({
            text: get(name, 'original', ''),
            value,
        }));
    }
}
const settingsStore = new SettingsStore();
export default settingsStore;
